import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../api";
import { useSession, type SessionUser } from "../stores/session";

export function RoleGuard({
  roles,
  children,
}: {
  roles?: SessionUser["role"][];
  children: ReactNode;
}) {
  const { user, loading } = useSession();
  const location = useLocation();

  if (!getToken()) return <Navigate to="/auth" replace />;
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#f3f0e6] text-[#6b644f]">
        正在确认身份...
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (user.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#f3f0e6] px-6">
        <div className="max-w-md rounded-xl border border-[#ded8c3] bg-white p-8 text-center shadow-sm">
          <h1 className="text-xl font-bold text-[#28251f]">无权限访问</h1>
          <p className="mt-3 text-sm leading-6 text-[#77705f]">当前账号没有访问这个管理页面的权限。</p>
          <a href={user.role === "mayor" || user.role === "super_admin" ? "/console/overview" : "/halls"} className="mt-6 inline-block rounded-lg bg-[#2f6e5b] px-5 py-2 text-sm font-bold text-white">
            返回{user.role === "mayor" || user.role === "super_admin" ? "控制台" : "小镇大厅"}
          </a>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
